// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2hFB_","buttons":"PendingPaymentAlert_buttons__3eMLm"};